import React from "react";
import PageBody from "Common/Custom/PageBody";
import { HeadingOne } from "Common/Custom/HeadingOne";
import AddItemBtn from "Common/Custom/AddItemBtn";
import GalleryListTable from "./Componates/GalleryListTable";

const GalleryList = () => {
  return (
    <PageBody
      card={true}
      headerchildren={
        <>
          <HeadingOne>Gallery List</HeadingOne>
          <AddItemBtn url="add-gallery" title="Create" />
        </>
      }
    >
      <div className="col-12">
        <GalleryListTable />
      </div>
    </PageBody>
  );
};

export default GalleryList;
